"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var react_toastify_1 = require("react-toastify");
var sampleSlice_1 = require("../redux/slice/sampleSlice");
var utils_1 = require("../utils");
var helpers_1 = require("../utils/helpers");
var ACButton_1 = require("./ACButton");
var ACCounter_1 = require("./ACCounter");
var ACDatePicker_1 = require("./ACDatePicker");
var ACWrapperContext_1 = require("./ACWrapperContext");
var INITIAL_SELECTEDCELL = {
    row: {},
    value: {},
    field: '',
};
var ACAddMoreTable = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var fieldName = props.name, _k = props.disabled, disabled = _k === void 0 ? false : _k, _l = props.thead, thead = _l === void 0 ? [] : _l, _m = props.color, color = _m === void 0 ? 'primary' : _m, _o = props.handlers, handlers = _o === void 0 ? [] : _o, rootState = props.rootState, context = props.context, _p = props.autoAddNewRow, autoAddNewRow = _p === void 0 ? false : _p;
    var dispatch = (0, react_redux_1.useDispatch)();
    var debouncedFetchMap = (0, react_1.useRef)({});
    var _q = (0, react_1.useState)([]), rows = _q[0], setRows = _q[1];
    var _r = (0, react_1.useState)({}), colOptions = _r[0], setColOptions = _r[1];
    var _s = (0, react_1.useState)(__assign({}, INITIAL_SELECTEDCELL)), selectedCell = _s[0], setSelectedCell = _s[1];
    var isEmptyRow = function (row, columns) {
        // Skip row_id when checking for emptiness
        var fieldNames = columns.map(function (col) { return col.name; });
        // Check if all fields are empty, null or undefined
        return fieldNames.every(function (fieldName) {
            var value = row[fieldName];
            // Check various forms of "emptiness"
            if (value === null || value === undefined || value === '') {
                return true;
            }
            // For objects (like selected options), check if it has any meaningful content
            if (typeof value === 'object' && value !== null) {
                // If it's an empty object or has only null/undefined values
                return (Object.keys(value).length === 0 ||
                    Object.values(value).every(function (v) { return v === null || v === undefined || v === ''; }));
            }
            return false;
        });
    };
    function createEmptyRow(id) {
        return thead.reduce(function (acc, curr) {
            acc[curr.name] = null;
            return acc;
        }, { row_id: id });
    }
    var name = ((_a = props === null || props === void 0 ? void 0 : props.tbody) === null || _a === void 0 ? void 0 : _a.storedLocation) ||
        ((_c = (_b = handlers.find(function (e) { return (e === null || e === void 0 ? void 0 : e.action) === 'changeState'; })) === null || _b === void 0 ? void 0 : _b.args) === null || _c === void 0 ? void 0 : _c.storedLocation) ||
        fieldName;
    var defaultState = helpers_1.Helper.getNestedValue((_e = (_d = context === null || context === void 0 ? void 0 : context.state) === null || _d === void 0 ? void 0 : _d.dynamic) === null || _e === void 0 ? void 0 : _e[rootState || ''], ((_f = props === null || props === void 0 ? void 0 : props.tbody) === null || _f === void 0 ? void 0 : _f.storedLocation) ? (_g = props === null || props === void 0 ? void 0 : props.tbody) === null || _g === void 0 ? void 0 : _g.storedLocation : name);
    var selectedCellState = helpers_1.Helper.getNestedValue((_j = (_h = context === null || context === void 0 ? void 0 : context.state) === null || _h === void 0 ? void 0 : _h.dynamic) === null || _j === void 0 ? void 0 : _j[rootState || ''], "".concat(fieldName, "_selectedCell"));
    var memoizedRows = (0, react_1.useMemo)(function () { return rows; }, [rows]);
    var memoizedSelectedCell = (0, react_1.useMemo)(function () {
        return [{}, null].includes(selectedCellState)
            ? __assign({}, INITIAL_SELECTEDCELL) : selectedCell;
    }, [selectedCellState, selectedCell]);
    var memoizedDefaultState = (0, react_1.useMemo)(function () { return defaultState; }, [defaultState]);
    (0, react_1.useEffect)(function () {
        if ((thead === null || thead === void 0 ? void 0 : thead.length) && (memoizedRows === null || memoizedRows === void 0 ? void 0 : memoizedRows.length) === 0) {
            var count = 0;
            if (Array.isArray(memoizedDefaultState) &&
                (memoizedDefaultState === null || memoizedDefaultState === void 0 ? void 0 : memoizedDefaultState.length) > 0) {
                count = memoizedDefaultState === null || memoizedDefaultState === void 0 ? void 0 : memoizedDefaultState.length;
            }
            initializeRowsAndOptions(count ? count - 1 : 0);
            if (Array.isArray(memoizedDefaultState) && (memoizedDefaultState === null || memoizedDefaultState === void 0 ? void 0 : memoizedDefaultState.length)) {
                var processedData = memoizedDefaultState.map(function (row, index) {
                    var processedRow = __assign({}, row);
                    // Ensure row has a row_id
                    if (!processedRow.row_id) {
                        processedRow.row_id = "".concat(name, "_").concat(index);
                    }
                    // Process each column with dataKey
                    thead.forEach(function (col) {
                        if (col.dataKey && col.dataKey !== col.name) {
                            var value = helpers_1.Helper.getNestedValue(row, col.dataKey);
                            processedRow[col.name] = value !== undefined ? value : null;
                        }
                    });
                    return processedRow;
                });
                setRows(JSON.parse(JSON.stringify(processedData)));
            }
            else {
                setRows([createEmptyRow("".concat(name, "_0"))]);
            }
        }
    }, [thead, memoizedRows, memoizedDefaultState]);
    // Separate effect to initialize options after rows are set
    (0, react_1.useEffect)(function () {
        if (rows.length > 0 && (thead === null || thead === void 0 ? void 0 : thead.length) > 0) {
            rows.forEach(function (row) {
                if (row.row_id) {
                    initializeRowsAndOptions(row.row_id);
                }
            });
        }
    }, [rows.length]); // Only run when rows length changes
    (0, react_1.useEffect)(function () {
        if (Array.isArray(memoizedDefaultState) &&
            (memoizedDefaultState === null || memoizedDefaultState === void 0 ? void 0 : memoizedDefaultState.length) > 0 &&
            JSON.stringify(memoizedDefaultState) !== JSON.stringify(rows)) {
            var processedData = memoizedDefaultState.map(function (row, index) {
                var processedRow = __assign({}, row);
                // Ensure row has a row_id
                if (!processedRow.row_id) {
                    processedRow.row_id = "".concat(name, "_").concat(index);
                }
                // Process each column with dataKey
                thead.forEach(function (col) {
                    if (col.dataKey && col.dataKey !== col.name) {
                        var value = helpers_1.Helper.getNestedValue(row, col.dataKey);
                        processedRow[col.name] = value !== undefined ? value : null;
                    }
                });
                return processedRow;
            });
            setRows(JSON.parse(JSON.stringify(processedData)));
            if (autoAddNewRow) {
                var lastRow = memoizedDefaultState[memoizedDefaultState.length - 1];
                // Modified check that properly handles zero values
                var validLastRow = Object.entries(lastRow)
                    .filter(function (_a) {
                    var key = _a[0];
                    return key !== 'row_id';
                }) // Exclude row_id from check
                    .some(function (_a) {
                    var _ = _a[0], value = _a[1];
                    return value !== null && value !== undefined && value !== '';
                });
                if (validLastRow) {
                    addRow();
                }
            }
        }
    }, [memoizedDefaultState, autoAddNewRow]);
    (0, react_1.useEffect)(function () {
        var handler = setTimeout(function () {
            // console.log('Rows changed:', memoizedRows);
            props.onChange(JSON.parse(JSON.stringify(memoizedRows)));
        }, 300);
        return function () {
            clearTimeout(handler);
        };
    }, [memoizedRows]);
    (0, react_1.useEffect)(function () {
        var handler = setTimeout(function () {
            dispatch((0, sampleSlice_1.setStateValue)({
                path: "".concat(rootState, ".").concat(fieldName, "_selectedCell"),
                value: memoizedSelectedCell,
            }));
        }, 300);
        return function () {
            clearTimeout(handler);
        };
    }, [rootState, name, memoizedSelectedCell]);
    var initializeRowsAndOptions = function (indexOrRowId) { return __awaiter(void 0, void 0, void 0, function () {
        var rowName, _i, thead_1, h;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    rowName = typeof indexOrRowId === 'string'
                        ? indexOrRowId
                        : "".concat(name, "_").concat(indexOrRowId);
                    _i = 0, thead_1 = thead;
                    _a.label = 1;
                case 1:
                    if (!(_i < thead_1.length)) return [3 /*break*/, 4];
                    h = thead_1[_i];
                    if (!((h === null || h === void 0 ? void 0 : h.element) === 'single-select' && (h === null || h === void 0 ? void 0 : h.endPoint))) return [3 /*break*/, 3];
                    return [4 /*yield*/, API_GET_Options({
                            endPoint: h === null || h === void 0 ? void 0 : h.endPoint,
                            searchText: '',
                            rowName: rowName,
                            colName: h.name,
                        })];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    _i++;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/, rowName];
            }
        });
    }); };
    var API_GET_Options = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
        var Utils, res, data_1, error_1;
        var endPoint = _b.endPoint, _c = _b.searchText, searchText = _c === void 0 ? '' : _c, _d = _b.rowName, rowName = _d === void 0 ? '' : _d, _e = _b.colName, colName = _e === void 0 ? '' : _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    if (!endPoint)
                        return [2 /*return*/];
                    Utils = (0, ACWrapperContext_1.getUtils)();
                    _f.label = 1;
                case 1:
                    _f.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Utils.makeApiCall("".concat(endPoint).concat((endPoint === null || endPoint === void 0 ? void 0 : endPoint.includes('?')) ? '&' : '?', "search=").concat(searchText), 'GET')];
                case 2:
                    res = _f.sent();
                    if (!res.status) {
                        react_toastify_1.toast.error(res.message, {
                            position: 'top-center',
                            autoClose: 2000,
                        });
                        return [2 /*return*/];
                    }
                    data_1 = res.data;
                    if (rowName && colName) {
                        setColOptions(function (prevOptions) {
                            var _a, _b;
                            return (__assign(__assign({}, prevOptions), (_a = {}, _a[rowName] = __assign(__assign({}, (prevOptions[rowName] || {})), (_b = {}, _b[colName] = data_1, _b)), _a)));
                        });
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _f.sent();
                    react_toastify_1.toast.error('Error', {
                        position: 'top-center',
                        autoClose: 2000,
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleFieldChange = function (rowIndex, field, value) {
        var _a;
        var updatedRows = __spreadArray([], rows, true);
        updatedRows[rowIndex] = __assign(__assign({}, updatedRows[rowIndex]), (_a = {}, _a[field] = value, _a));
        // setRows((prevRows) => {
        //   const updated = [...prevRows];
        //   updated[rowIndex] = { ...updated[rowIndex], [field]: value };
        //   return updated;
        // });
        // setSelectedCell({ row, value, field });
        setRows(updatedRows);
        setSelectedCell({ row: updatedRows[rowIndex], value: value, field: field });
    };
    var addRow = function () {
        setRows(function (prevRows) {
            var _a;
            var lastRowId = (_a = prevRows === null || prevRows === void 0 ? void 0 : prevRows[prevRows.length - 1]) === null || _a === void 0 ? void 0 : _a.row_id;
            var lastIndex = lastRowId
                ? parseInt(lastRowId.split('_').slice(-1)[0], 10)
                : 0;
            var nextIndex = lastIndex + 1;
            var newRowId = "".concat(name, "_").concat(nextIndex);
            initializeRowsAndOptions(nextIndex);
            return __spreadArray(__spreadArray([], prevRows, true), [createEmptyRow(newRowId)], false);
        });
    };
    var deleteRow = function (index, key) {
        var deletedRow = rows[index];
        setSelectedCell({
            row: deletedRow,
            value: deletedRow,
            field: 'delete',
        });
        setRows(function (prevRows) {
            var updatedRows = __spreadArray([], prevRows, true);
            updatedRows.splice(index, 1);
            return (updatedRows === null || updatedRows === void 0 ? void 0 : updatedRows.length) === 0
                ? [createEmptyRow("".concat(name, "_0"))]
                : updatedRows;
        });
        setColOptions(function (prev) {
            var updated = __assign({}, prev);
            delete updated[key];
            return updated;
        });
    };
    var deleteRowBtn = function (rowId, key) {
        return ((0, jsx_runtime_1.jsx)(ACButton_1.ACButton, { id: "delete-row-".concat(rowId), name: "delete-row-".concat(rowId), color: "danger", className: "w-full", iconClassName: "aci aci-delete aci-dynamic-size size-[14px]", size: "small", variant: "ghost", onClick: function () { return deleteRow(rowId, key); }, disabled: disabled, "data-testid": "delete-row-".concat(rowId) }));
    };
    var addRowBtn = function () {
        return ((0, jsx_runtime_1.jsx)(ACButton_1.ACButton, { id: "add-row", name: "add-row", iconClassName: "aci aci-add aci-dynamic-size size-[14px]", variant: "ghost", size: "small", color: "success", className: "w-full", onClick: function () { return addRow(); }, disabled: props.disabled, "data-testid": "add-row" }));
    };
    var inputElement = function (_a) {
        var key = _a.key, name = _a.name, subFieldName = _a.subFieldName, value = _a.value, placeholder = _a.placeholder, disabled = _a.disabled, element = _a.element, rowIndex = _a.rowIndex, _b = _a.prefix, prefix = _b === void 0 ? null : _b;
        return ((0, jsx_runtime_1.jsx)("form", { autoComplete: "off", children: (0, jsx_runtime_1.jsx)(antd_1.Input, { name: subFieldName || name, value: value !== null && value !== void 0 ? value : '', placeholder: placeholder, prefix: prefix, disabled: disabled, autoComplete: "off", onChange: function (e) {
                    var _a;
                    var _b;
                    var val = e.target.value;
                    if (['input-split-number', 'input-number'].includes(element)) {
                        var newValue = val.replace(/[^0-9.]/g, '');
                        newValue = newValue.replace(/^0+(?=\d)/, '');
                        newValue = newValue.replace(/(\..*?)\.+/g, '$1');
                        val = newValue;
                        if (element === 'input-split-number') {
                            var existing = ((_b = rows === null || rows === void 0 ? void 0 : rows[rowIndex]) === null || _b === void 0 ? void 0 : _b[name]) || {};
                            val = __assign(__assign({}, existing), (_a = {}, _a[subFieldName] = val, _a));
                        }
                    }
                    handleFieldChange(rowIndex, name, val);
                } }, "".concat(key, "_").concat(subFieldName || name)) }, "".concat(key, "_").concat(subFieldName || name)));
    };
    return ((0, jsx_runtime_1.jsxs)("table", { className: "w-full rounded-md add-more-table ".concat(props.disabled ? 'cursor-not-allowed' : '', " ").concat(props.className), style: { border: '5px' }, children: [(0, jsx_runtime_1.jsx)("thead", { className: "".concat(disabled || color === 'default' ? 'bg-[#EBECF8] text-[#000]' : 'bg-primary text-white', "  rounded-md"), children: (0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("th", { className: "p-2 text-left rounded-tl-md", style: { width: '10px', maxWidth: '10px' }, children: "#" }), thead === null || thead === void 0 ? void 0 : thead.map(function (h, index) {
                            var _a;
                            return ((0, jsx_runtime_1.jsx)("th", { className: "p-2 text-left ".concat(props.disabled && index === ((_a = thead === null || thead === void 0 ? void 0 : thead.length) !== null && _a !== void 0 ? _a : 0) - 1 ? 'rounded-tr-md' : ''), style: { width: (h === null || h === void 0 ? void 0 : h.width) || '200px' }, children: h.label }, h.name));
                        }), !props.disabled && ((0, jsx_runtime_1.jsx)("th", { className: "p-2 text-left rounded-tr-md", style: { width: '50px' } }))] }) }), (0, jsx_runtime_1.jsx)("tbody", { children: (disabled ? rows.filter(function (row) { return !isEmptyRow(row, thead); }) : rows).map(function (row, rowIndex) { return ((0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("td", { className: "text-center text-gray-4 text-sm font-medium", children: rowIndex + 1 }), thead === null || thead === void 0 ? void 0 : thead.map(function (col) {
                            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
                            var key = row === null || row === void 0 ? void 0 : row.row_id;
                            var cellContent = null;
                            var isDisabled = disabled || col.disabled;
                            if ((col === null || col === void 0 ? void 0 : col.element) === 'single-select') {
                                var value = (row === null || row === void 0 ? void 0 : row[col === null || col === void 0 ? void 0 : col.name]) || undefined;
                                cellContent =
                                    isDisabled && (col === null || col === void 0 ? void 0 : col.mode) === 'multiple' ? ((0, jsx_runtime_1.jsx)("p", { className: "text-[13px] text-dark p-2", children: value.map(function (v) { return v === null || v === void 0 ? void 0 : v.label; }).join(', ') })) : ((0, jsx_runtime_1.jsx)(antd_1.Select, { showSearch: true, options: Array.isArray(col === null || col === void 0 ? void 0 : col.options)
                                            ? col === null || col === void 0 ? void 0 : col.options
                                            : ((_a = colOptions === null || colOptions === void 0 ? void 0 : colOptions[key]) === null || _a === void 0 ? void 0 : _a[col === null || col === void 0 ? void 0 : col.name]) || [], style: { width: '100%' }, mode: col === null || col === void 0 ? void 0 : col.mode, placeholder: col === null || col === void 0 ? void 0 : col.placeholder, value: (row === null || row === void 0 ? void 0 : row[col === null || col === void 0 ? void 0 : col.name]) || undefined, disabled: disabled || col.disabled, onSearch: function (searchText) {
                                            if (!(col === null || col === void 0 ? void 0 : col.endPoint))
                                                return;
                                            var debouncedKey = "".concat(key, "_").concat(col.name);
                                            if (!debouncedFetchMap.current[debouncedKey]) {
                                                debouncedFetchMap.current[debouncedKey] =
                                                    utils_1.Utils.debounce(function (text) { return __awaiter(void 0, void 0, void 0, function () {
                                                        return __generator(this, function (_a) {
                                                            switch (_a.label) {
                                                                case 0: return [4 /*yield*/, API_GET_Options({
                                                                        endPoint: col === null || col === void 0 ? void 0 : col.endPoint,
                                                                        searchText: text,
                                                                        rowName: key,
                                                                        colName: col.name,
                                                                    })];
                                                                case 1:
                                                                    _a.sent();
                                                                    return [2 /*return*/];
                                                            }
                                                        });
                                                    }); }, 500);
                                            }
                                            debouncedFetchMap.current[debouncedKey](searchText);
                                        }, filterOption: ((_b = col === null || col === void 0 ? void 0 : col.options) === null || _b === void 0 ? void 0 : _b.length) ? undefined : false, onChange: function (value) {
                                            var _a;
                                            // console.log('__value__!', value);
                                            var ops = Array.isArray(col === null || col === void 0 ? void 0 : col.options)
                                                ? col === null || col === void 0 ? void 0 : col.options
                                                : ((_a = colOptions === null || colOptions === void 0 ? void 0 : colOptions[key]) === null || _a === void 0 ? void 0 : _a[col === null || col === void 0 ? void 0 : col.name]) || [];
                                            var selectedOption;
                                            if (Array.isArray(value)) {
                                                selectedOption = value
                                                    ? value.map(function (val) {
                                                        return ((ops === null || ops === void 0 ? void 0 : ops.find(function (op) { return op.value === val; })) || {
                                                            value: val,
                                                            label: val,
                                                        });
                                                    })
                                                    : [];
                                            }
                                            else {
                                                selectedOption = ops.find(function (option) { return option.value === value; });
                                            }
                                            handleFieldChange(rowIndex, col === null || col === void 0 ? void 0 : col.name, selectedOption);
                                        } }, "".concat(key, "_").concat(col === null || col === void 0 ? void 0 : col.name)));
                            }
                            else if ((col === null || col === void 0 ? void 0 : col.element) === 'input-text' ||
                                (col === null || col === void 0 ? void 0 : col.element) === 'input-number' ||
                                (col === null || col === void 0 ? void 0 : col.element) === 'input-split-number') {
                                if ((col === null || col === void 0 ? void 0 : col.element) === 'input-split-number') {
                                    var field1Name = (_d = (_c = col === null || col === void 0 ? void 0 : col.subFields) === null || _c === void 0 ? void 0 : _c.names) === null || _d === void 0 ? void 0 : _d[0];
                                    var field2Name = (_f = (_e = col === null || col === void 0 ? void 0 : col.subFields) === null || _e === void 0 ? void 0 : _e.names) === null || _f === void 0 ? void 0 : _f[1];
                                    var field1Placeholder = (_h = (_g = col === null || col === void 0 ? void 0 : col.subFields) === null || _g === void 0 ? void 0 : _g.placeholders) === null || _h === void 0 ? void 0 : _h[0];
                                    var field2Placeholder = (_k = (_j = col === null || col === void 0 ? void 0 : col.subFields) === null || _j === void 0 ? void 0 : _j.placeholders) === null || _k === void 0 ? void 0 : _k[1];
                                    cellContent = ((0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-1", children: [inputElement({
                                                key: "".concat(key, "_").concat(field1Name || ''),
                                                name: col === null || col === void 0 ? void 0 : col.name,
                                                subFieldName: field1Name,
                                                value: (_m = (_l = row === null || row === void 0 ? void 0 : row[col === null || col === void 0 ? void 0 : col.name]) === null || _l === void 0 ? void 0 : _l[field1Name]) !== null && _m !== void 0 ? _m : '',
                                                placeholder: field1Placeholder,
                                                disabled: disabled || (col === null || col === void 0 ? void 0 : col.disabled),
                                                element: col === null || col === void 0 ? void 0 : col.element,
                                                rowIndex: rowIndex,
                                                prefix: col === null || col === void 0 ? void 0 : col.prefix,
                                            }), (0, jsx_runtime_1.jsx)("span", { className: "text-gray-300", children: "/" }), inputElement({
                                                key: "".concat(key, "_").concat(field2Name || ''),
                                                name: col === null || col === void 0 ? void 0 : col.name,
                                                subFieldName: field2Name,
                                                value: (_p = (_o = row === null || row === void 0 ? void 0 : row[col === null || col === void 0 ? void 0 : col.name]) === null || _o === void 0 ? void 0 : _o[field2Name]) !== null && _p !== void 0 ? _p : '',
                                                placeholder: field2Placeholder,
                                                disabled: disabled || (col === null || col === void 0 ? void 0 : col.disabled),
                                                element: col === null || col === void 0 ? void 0 : col.element,
                                                rowIndex: rowIndex,
                                                prefix: col === null || col === void 0 ? void 0 : col.prefix,
                                            })] }, col === null || col === void 0 ? void 0 : col.name));
                                }
                                else {
                                    cellContent = inputElement({
                                        key: key,
                                        name: col === null || col === void 0 ? void 0 : col.name,
                                        value: (_q = row === null || row === void 0 ? void 0 : row[col === null || col === void 0 ? void 0 : col.name]) !== null && _q !== void 0 ? _q : '',
                                        placeholder: col === null || col === void 0 ? void 0 : col.placeholder,
                                        disabled: disabled || (col === null || col === void 0 ? void 0 : col.disabled),
                                        element: col === null || col === void 0 ? void 0 : col.element,
                                        rowIndex: rowIndex,
                                        prefix: col === null || col === void 0 ? void 0 : col.prefix,
                                    });
                                }
                            }
                            else if ((col === null || col === void 0 ? void 0 : col.element) === 'datetimepicker') {
                                cellContent = ((0, jsx_runtime_1.jsx)(ACDatePicker_1.ACDatePickerElement, { name: "".concat(key, "_").concat(col === null || col === void 0 ? void 0 : col.name), disabled: disabled || col.disabled, enabledDates: col.enabledDates, value: (row === null || row === void 0 ? void 0 : row[col === null || col === void 0 ? void 0 : col.name]) || '', isDateTime: col === null || col === void 0 ? void 0 : col.isDateTime, format: col === null || col === void 0 ? void 0 : col.format, label: "", className: "add-more-table_datepicker ".concat(col === null || col === void 0 ? void 0 : col.className), onChange: function (value) {
                                        return handleFieldChange(rowIndex, col === null || col === void 0 ? void 0 : col.name, value);
                                    } }, "".concat(key, "_").concat(col === null || col === void 0 ? void 0 : col.name)));
                            }
                            else if ((col === null || col === void 0 ? void 0 : col.element) === 'counter') {
                                cellContent = ((0, jsx_runtime_1.jsx)(ACCounter_1.ACCounter, { name: "".concat(key, "_").concat(col === null || col === void 0 ? void 0 : col.name), disabled: disabled || col.disabled, value: (row === null || row === void 0 ? void 0 : row[col === null || col === void 0 ? void 0 : col.name]) || 1, className: col === null || col === void 0 ? void 0 : col.className, onChange: function (value) {
                                        return handleFieldChange(rowIndex, col === null || col === void 0 ? void 0 : col.name, value);
                                    } }, "".concat(key, "_").concat(col === null || col === void 0 ? void 0 : col.name)));
                            }
                            return cellContent ? ((0, jsx_runtime_1.jsx)("td", { children: cellContent }, "".concat(key, "_").concat(col === null || col === void 0 ? void 0 : col.name))) : null;
                        }), !disabled && ((0, jsx_runtime_1.jsx)("td", { className: "p-1", children: rowIndex === (rows === null || rows === void 0 ? void 0 : rows.length) - 1 ? ((0, jsx_runtime_1.jsxs)("div", { className: "flex gap-1 justify-center", children: [(rows === null || rows === void 0 ? void 0 : rows.length) > 1 && deleteRowBtn(rowIndex, row === null || row === void 0 ? void 0 : row.row_id), addRowBtn()] })) : (deleteRowBtn(rowIndex, row === null || row === void 0 ? void 0 : row.row_id)) }))] }, row === null || row === void 0 ? void 0 : row.row_id)); }) })] }));
};
exports.default = ACAddMoreTable;
